import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Div from '../Div';
import { localizePath } from '../../helper/localizedPath';

export default function PageHeading({
  title,
  bgSrc,
  pageLinkText,
  parentLinkText,
  parentLink,
}) {
  const { t, i18n } = useTranslation();
  const language = i18n.language === 'en' ? 'en' : 'cs';

  // Sestavíme seznam breadcrumb položek (Domů → [parent] → aktuální)
  const items = [{ name: t('nav.home'), url: `https://www.stablerecords.cz${language === 'en' ? '/en' : '/'}` }];
  if (parentLinkText && parentLink) {
    const parentUrl = `https://www.stablerecords.cz${localizePath(parentLink, language)}`;
    items.push({ name: parentLinkText, url: parentUrl });
  }
  items.push({ name: pageLinkText });

  // BreadcrumbList JSON-LD pro Google rich results
  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: item.name,
      ...(item.url ? { item: item.url } : {}),
    })),
  };

  return (
    <Div
      className="cs-page_heading cs-style1 cs-center text-center cs-bg"
      style={{ backgroundImage: `url(${bgSrc})` }}
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      </Helmet>
      <Div className="container">
        <Div className="cs-page_heading_in">
          <h1 className="cs-page_title cs-font_50 cs-white_color">{title}</h1>
          <ol className="breadcrumb text-uppercase">
            <li className="breadcrumb-item">
              <Link to={localizePath('/', language)}>{t('nav.home')}</Link>
            </li>
            {parentLinkText && parentLink && (
              <li className="breadcrumb-item">
                <Link to={localizePath(parentLink, language)}>{parentLinkText}</Link>
              </li>
            )}
            <li className="breadcrumb-item active">{pageLinkText}</li>
          </ol>
        </Div>
      </Div>
    </Div>
  );
}
